import { render, staticRenderFns } from "./FulfillmentOrderView.vue?vue&type=template&id=237dfb2e"
import script from "./FulfillmentOrderView.vue?vue&type=script&lang=js"
export * from "./FulfillmentOrderView.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentOrderView.vue?vue&type=style&index=0&id=237dfb2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports